import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { MyTechRadarClient } from './lib/MyTechRadarClient';
import { techRadarApiRef } from '@backstage/plugin-tech-radar';
import { MockSentryApi, sentryApiRef } from '@backstage/plugin-sentry';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: techRadarApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => new MyTechRadarClient(configApi),
  }),
  createApiFactory(sentryApiRef, new MockSentryApi())
];
